import InvoiceModal from 'app/components/Core/Invoice/Modal/Modal'
import { RecordType } from 'app/constants/GlobalTypes'
import { useShow } from 'app/lib/hooks/useApi'
import { useCurrentContact } from 'app/lib/hooks/useCurrent'
import useTitle from 'app/lib/hooks/useTitle'
import ScriptService from 'app/lib/services/ScriptService'
import { PageProps } from 'app/pages/typing'
import { Routes } from 'app/routes/Routes'
import { useEffect } from 'react'
import React from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

const Show: React.FC<PageProps> = (props) => {
  const { titlelizer } = useTitle(props)
  const { email, hubspot_sync } = useCurrentContact()
  const navigate = useNavigate()
  const { invoice_id } = useParams<{ invoice_id: string }>()
  const [searchParams] = useSearchParams()
  const { loading, response: invoice, execute } = useShow<IInvoice>(RecordType.invoice)

  useEffect(() => {
    execute({ id: Number(invoice_id) })
    ScriptService.embedHubspotScript(email, hubspot_sync)
  }, [invoice_id, email, hubspot_sync])

  const closeModal = () => {
    navigate({ pathname: Routes.Invoice.collection().index, search: searchParams.toString() })
  }

  return (
    <InvoiceModal
      member={invoice}
      props={{
        loading: loading,
        title: titlelizer({ id: invoice?.number }),
        handleOnClose: closeModal
      }}
    />
  )
}

export default Show
